<template>
    <div>
        <div class="row cart_block mt_sm">
            <div class="col-12">
                <div class="info_title cart_group_title">
                    Выберите плательщика из списка, чтобы применить к товарам в
                    корзине <b>скидку для постоянных клиентов</b>. Эта скидка
                    зависит от суммы покупок за год и привязана к конкетному
                    физическому, юридическому лицу или индивидуальному
                    предпринимателю.
                </div>
                <div class="info_body">
                    <div class="form-inline ki_options">
                        <input
                            class="form-control info_body_selected"
                            :class="{ 'is-invalid': errors.payer }"
                            v-model="payer.name"
                            readonly
                        />
                        <button
                            type="button"
                            class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalPayer"
                        >
                            Выбрать плательщика
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- //cart_block -->

        <!-- title -->
        <div class="row ki_block_title block_total mt_xs">
            <div class="col-12">
                <span class="other_lg">Сумма {{ oldAmount }} р.</span>
                <span class="sale_lg">Скидка {{ discount }} р.</span>
                <span class="price_lg">Со скидкой {{ amount }} р.</span>
            </div>
        </div>
        <!-- // title -->

        <!-- Modal -->
        <order-form-payer-modal></order-form-payer-modal>
    </div>
</template>

<script>
export default {
    data: function () {
        return {};
    },
    methods: {},
    computed: {
        // Выбранный плательщик
        payer() {
            console.log(this.$store.state.order.payer);
            return this.$store.state.order.payer;
        },
        errors() {
            return this.$store.state.order.errors;
        },
        amount() {
            return parseFloat(this.$store.getters["order/amount"]).toFixed(2);
        },
        oldAmount() {
            return parseFloat(this.$store.getters["order/oldAmount"]).toFixed(2);
        },
        discount() {
            return parseFloat(this.$store.getters["order/discount"]).toFixed(2);
        },
        deliveryPrice() {
            return parseFloat(this.$store.getters["order/deliveryPrice"]).toFixed(2);
        },
        total() {
            return parseFloat(this.$store.getters["order/total"]).toFixed(2);
        },
    },
    mounted() {
        this.$store.dispatch("payer/getPayers");
    },
};
</script>
